import {
  ISubTaskBackgroundCheckInviteDenormalized,
  SubTaskStatus
} from '@dadohr/shared/domainTypes/experience';
import { Typography } from '@material-ui/core';
import { Link as LinkIcon } from 'lucide-react';
import React from 'react';
import { ColoredChipLight } from '../../../../../components/ColoredChip';
import { CompleteLink } from '../../../../../components/CompletionButtons';
import { useUnsafeTranslation } from '../../../../../i18next';
import {
  FlexContainer,
  FlexContainerVertical
} from '../../../../../layout/Flex';

// Shared renderer used both by the participant-facing Task view (mode="LIVE")
// and the admin-facing TaskBuilder preview (mode="PREVIEW"). The two call sites
// previously duplicated this block; consolidating here keeps the link / status
// chip / caption copy in one place.
//
// CTA is a text-style link (CompleteLink, not a filled button) with a chain
// icon — matches the email renderer. Link renders unconditionally so PREVIEW
// (no URL) shows the same CTA shape as LIVE. Falls back to '#' when URL is
// missing — SC-30502 pre-create makes URL effectively always present in live
// participant views.
export const SubTaskBackgroundCheckInvite = ({
  s,
  status,
  mode
}: {
  s: ISubTaskBackgroundCheckInviteDenormalized;
  status: SubTaskStatus;
  mode: 'LIVE' | 'PREVIEW';
}) => {
  const { t } = useUnsafeTranslation();
  const linkText = s.data.linkText || t('Complete your check here');
  const url = s.data.invitation?.url;
  return (
    <FlexContainerVertical fullWidth spacing={1}>
      <FlexContainer alignItems="center" spacing={1}>
        <CompleteLink
          href={url || '#'}
          status={SubTaskStatus.OPEN}
          startIcon={<LinkIcon size={16} strokeWidth={2.75} />}
          mode={mode}
        >
          {linkText}
        </CompleteLink>
      </FlexContainer>
      <FlexContainer>
        <strong>{`${t('Check status')}:`}</strong>
        <ColoredChipLight
          variant="rounded"
          size="small"
          color={
            status === SubTaskStatus.DONE
              ? 'green'
              : status === SubTaskStatus.SKIPPED
              ? 'gray'
              : 'blue'
          }
        >
          {status === SubTaskStatus.DONE
            ? t('Submitted')
            : status === SubTaskStatus.SKIPPED
            ? t('Skipped')
            : t('To Do')}
        </ColoredChipLight>
      </FlexContainer>
      <Typography variant="caption">
        {t(
          'This status will automatically update once you have submitted your details on the Checkr platform.'
        )}
      </Typography>
    </FlexContainerVertical>
  );
};
